import axios from "../../utils/axios";

export type TabFacilitiesStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabFacilitiesState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-facilities-state`)
    .then((response: { data: { data: TabFacilitiesStateResponse } }) => response.data.data)
